<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="300px"
    style="background-color: #e4eaec"
  >
    <v-card>
      <!-- <v-card-title style="background-color: #282970; color: white">
        <span>در حال پردازش...</span>
      </v-card-title> -->
      <v-card-text>
        <v-container>
          <v-row>
            <v-col style="text-align: center">
              <span
                style="
                  font-family: Iransans;
                  font-size: 10px;
                  color: black;
                  font-weight: bold;
                  color: green;
                "
              >
                <v-progress-circular :size="50" color="#263238" indeterminate />
                <br />
                <div style="width: 100%; text-align: center; margin-top: 15px">
                  <span
                    style="color: #263238; font-weight: bold; font-size: 13px"
                    >لطفا منتظر بمانید ...</span
                  >
                </div>
              </span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "LoadingDialog",
  props: {
    visible: Boolean,
  },
  data: () => ({}),
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style scoped>
svg {
  transform: rotate(-90deg);
  stroke-dasharray: 251; /* (2PI * 40px) */
  stroke-dashoffset: 251;
  animation: offsettozero 5s linear forwards;
}

@keyframes offsettozero {
  to {
    stroke-dashoffset: 0;
  }
}
</style>
